import {IValuesStore} from "Stores/Values/types";
import {inject, observer} from "mobx-react";
import React from "react";
import {Values} from "@src/Tools/Values";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import {observable} from "mobx";
import {RegenerateSecretsContainer} from "./styles";
interface IRegenerateSecretsProps {
  handleResetLocationSecrets: () => void;
  values?: IValuesStore;
}
@inject("values")
@observer
export class RegenerateSecrets extends React.Component<IRegenerateSecretsProps> {
  @observable showConfirmDialog: boolean = false;

  handleShowConfirmDialog() {
    this.showConfirmDialog = true;
  }

  handleCloseConfirmDialog() {
    this.showConfirmDialog = false;
  }

  async handleClearLocationSecrets() {
    this.handleCloseConfirmDialog();
    this.props.handleResetLocationSecrets();
  }

  render() {
    return (
      <>
        <RegenerateSecretsContainer id={"regenerate-secrets-container"}>
          <span>
            {Values.getLocalizationValue("deploymentVariablesWasDownloaded")}
          </span>

          <Button
            variant={"contained"}
            color="primary"
            onClick={this.handleShowConfirmDialog.bind(this)}
          >
            {Values.getLocalizationValue("regenerateSecrets")}
          </Button>
        </RegenerateSecretsContainer>

        <Dialog
          maxWidth={false}
          open={this.showConfirmDialog}
          onClose={this.handleCloseConfirmDialog.bind(this)}
          style={{padding: 24}}
        >
          <DialogTitle id="person-dialog-title">
            {Values.getLocalizationValue("regenerateSecrets")}
          </DialogTitle>

          <DialogContent>
            {Values.getLocalizationValue("thisWillBreakVesselSync")}
          </DialogContent>

          <DialogActions style={{padding: 24}}>
            <Button
              variant={"outlined"}
              onClick={this.handleCloseConfirmDialog.bind(this)}
              color="default"
            >
              {Values.getLocalizationValue("cancel")}
            </Button>

            <Button
              variant={"contained"}
              onClick={this.handleClearLocationSecrets.bind(this)}
              color="primary"
            >
              {Values.getLocalizationValue("confirm")}
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}